// extracted by mini-css-extract-plugin
export default {"rating":"Rating_rating__bPBtY","full":"Rating_full__Pwrwb","empty":"Rating_empty__v7yIi"};